export function catchError(errMsg: string, errCallback?: (e: Error, msg: string) => void) {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    return {
      value: async function (...args: any) {
        try {
          return await descriptor.value.apply(this, args);
        } catch (e: any) {
          errCallback?.(e, errMsg);
        }
      },
    };
  };
}
